import { Link } from "react-router-dom";
import {
  DOC_VERSION_LABEL,
  CONDIZIONI_TITLE,
  CONDIZIONI_BODY,
  CONDIZIONI_VERSION_LABEL,
  ADDENDUM_TITLE,
  ADDENDUM_BODY,
  ADDENDUM_PREMESSA,
  ADDENDUM_VERSION_LABEL,
  PRIVACY_TITLE,
  PRIVACY_BODY,
  PRIVACY_VERSION_LABEL,
  DPA_TITLE,
  DPA_BODY,
  DPA_PREMESSA,
  DPA_VERSION_LABEL,
} from "@/legal/legalDocs";

function LegalShell({ title, premessa, articles, versionLabel }) {
  return (
    <div className="min-h-screen bg-[#F4F7FB] py-12 px-4" data-testid="legal-page">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-sm border border-[#0D1F3C]/8 p-8 sm:p-12">
        <div className="mb-8">
          <Link to="/login" className="text-sm text-[#1B4FD8] hover:underline" data-testid="legal-back-link">
            &larr; Torna a SELLY
          </Link>
        </div>
        <h1 className="text-3xl font-bold text-[#0D1F3C] mb-2" data-testid="legal-title">{title}</h1>
        <p className="text-xs uppercase tracking-wider text-[#0D1F3C]/40 mb-8">
          XFORMANCE GROUP S.r.l. &middot; SELLY&reg;
        </p>
        {premessa && (
          <div className="mb-6 p-4 bg-[#1B4FD8]/5 border-l-4 border-[#1B4FD8] rounded">
            <p className="text-sm font-medium text-[#0D1F3C] mb-1">Premessa</p>
            <p className="text-sm text-[#0D1F3C]/80 leading-relaxed">{premessa}</p>
          </div>
        )}
        <div className="space-y-6">
          {articles.map((a) => (
            <section key={a.art} className="border-b border-[#0D1F3C]/5 pb-5 last:border-0">
              <h2 className="text-base font-semibold text-[#0D1F3C] mb-2">{a.art}</h2>
              <p className="text-sm text-[#0D1F3C]/80 leading-relaxed whitespace-pre-wrap">{a.text}</p>
            </section>
          ))}
        </div>
        <div className="mt-12 pt-6 border-t border-[#0D1F3C]/8 text-center">
          <p className="text-xs text-[#0D1F3C]/40" data-testid="legal-version">{versionLabel || DOC_VERSION_LABEL}</p>
        </div>
      </div>
    </div>
  );
}

export function CondizioniServizioPage() {
  return <LegalShell title={CONDIZIONI_TITLE} articles={CONDIZIONI_BODY} versionLabel={CONDIZIONI_VERSION_LABEL} />;
}

export function AddendumAgenziePage() {
  return <LegalShell title={ADDENDUM_TITLE} premessa={ADDENDUM_PREMESSA} articles={ADDENDUM_BODY} versionLabel={ADDENDUM_VERSION_LABEL} />;
}

export function PrivacyPage() {
  return <LegalShell title={PRIVACY_TITLE} articles={PRIVACY_BODY} versionLabel={PRIVACY_VERSION_LABEL} />;
}

export function DpaPage() {
  return <LegalShell title={DPA_TITLE} premessa={DPA_PREMESSA} articles={DPA_BODY} versionLabel={DPA_VERSION_LABEL} />;
}
